import { Link } from 'react-router-dom';
import { useInView } from '../../../hooks/useInView';

const benefits = [
  { icon: 'ri-shield-check-line', title: 'Garantía total', desc: 'En todas las reparaciones realizadas en el taller.' },
  { icon: 'ri-time-line', title: 'Plazos cumplidos', desc: 'Entregamos en el tiempo acordado, sin excusas.' },
  { icon: 'ri-customer-service-2-line', title: 'Atención directa', desc: 'Hablas directamente con el mecánico que trabaja tu coche.' },
];

const WhyUsSection = () => {
  const [sectionRef, inView] = useInView(0.1);
  const [cardsRef, cardsInView] = useInView(0.1);

  return (
    <section className="relative bg-black py-20 px-6 overflow-hidden">
      <div className="absolute inset-0">
        <img
          alt=""
          className="w-full h-full object-cover object-center opacity-8"
          loading="lazy"
          decoding="async"
          src="https://public.readdy.ai/ai/img_res/8eedd1e0a85a99e19820c77f1022c822.jpg"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black via-black/95 to-black/70" />
      </div>

      {/* Yellow side accent */}
      <div className="absolute left-0 top-0 bottom-0 w-0.5 bg-gradient-to-b from-transparent via-yellow-400/40 to-transparent" />

      <div className="relative z-10 max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">

          {/* Left */}
          <div
            ref={sectionRef}
            className={`transition-all duration-800 ${
              inView ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-10'
            }`}
          >
            <div className="inline-flex items-center gap-2 mb-5">
              <span className="w-5 h-px bg-yellow-400" />
              <span className="text-yellow-400 text-[10px] font-bold uppercase tracking-[0.3em]">Por qué elegirnos</span>
            </div>
            <h2 className="font-display text-5xl md:text-6xl uppercase leading-none text-white tracking-wide mb-2">
              Reparación
            </h2>
            <h2 className="font-display text-5xl md:text-6xl uppercase leading-none text-yellow-400 tracking-wide mb-6">
              Integral
            </h2>
            <p className="text-zinc-400 text-sm leading-relaxed max-w-sm mb-8 font-light">
              Equipo de expertos, tecnología de última generación y procesos probados para
              devolver tu vehículo a su estado óptimo.
            </p>
            <div className="flex flex-col sm:flex-row gap-3">
              <Link
                to="/contacto"
                className="group inline-flex items-center gap-2.5 bg-yellow-400 text-black px-7 py-3.5 text-xs font-bold uppercase tracking-widest hover:bg-yellow-300 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                Presupuesto gratuito
                <i className="ri-arrow-right-line transition-transform duration-300 group-hover:translate-x-1" />
              </Link>
              <a
                href="tel:+34666365922"
                className="inline-flex items-center gap-2.5 border border-zinc-700 text-zinc-300 hover:border-yellow-400/40 hover:text-yellow-400 px-7 py-3.5 text-xs font-bold uppercase tracking-widest transition-all duration-300 whitespace-nowrap cursor-pointer hover:bg-yellow-400/5"
              >
                <i className="ri-phone-line" />
                Llamar ahora
              </a>
            </div>
          </div>

          {/* Cards */}
          <div
            ref={cardsRef}
            className="grid grid-cols-2 gap-3"
          >
            {benefits.map((b, i) => (
              <div
                key={b.title}
                className={`group bg-zinc-900/60 border border-zinc-800 hover:border-yellow-400/30 hover:bg-yellow-400/4 p-5 transition-all duration-400 cursor-default ${
                  cardsInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
                }`}
                style={{ transitionDuration: '600ms', transitionDelay: `${i * 0.1}s` }}
              >
                <div className="w-9 h-9 flex items-center justify-center bg-yellow-400/10 border border-yellow-400/15 text-yellow-400 mb-3 group-hover:bg-yellow-400/15 transition-colors">
                  <i className={`${b.icon} text-sm`} />
                </div>
                <p className="text-white text-xs font-bold uppercase tracking-wide mb-1.5">{b.title}</p>
                <p className="text-zinc-500 text-xs leading-relaxed">{b.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyUsSection;
